import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
*{
    margin:0;
    padding:0;
    box-sizing:border-box;
}
body{ 
    font-family: 'Odibee Sans', cursive;
    overflow-x:hidden;
    color:${({ theme }) => (theme ? 'white' : 'black')};
    transition:0.3s ease-in-out;
    background:${({ theme }) => (theme ? '#0f0f0f' : '#ffffff')};
}
input,textarea{
    font-family: 'Odibee Sans', cursive;
}
button{
  font-family: 'Odibee Sans', cursive;
  cursor:pointer;
  color:white;
  background:#50C1E9;
  border:none;
  border-radius:0.4rem;
  padding:0.5rem 1rem;
  font-size:1.2rem
}
.plain-btn{
    cursor:pointer;
  background:inherit;
  border:none;
  border-radius:0.4rem;
  padding:0.5rem 0rem;
  font-size:1.2rem;
  color:${({ theme }) => (theme ? 'white' : 'black')};
  &:hover{
      color:#50C1E9;
  }
  display:flex;
  align-items:center;
  gap:0.1rem
}

a{
    text-decoration: none;
    color:${({ theme }) => (theme ? 'white' : 'black')};
}

.App{
    background:${({ theme }) => (theme ? '#0f0f0f' : '#ffffff')};
}
h2,h3{
    font-weight:lighter
}
`;
export default GlobalStyle;
